import React from "react";
import { Link, useParams } from 'react-router-dom';
import CourseProgress from "../CourseProgress";
import { StickyContainer, Sticky } from "react-sticky";
import CourseNav from "./CourseNav";

const CourseLesson = (props) => {

    const { lesson, topic } = useParams();

    return (
        <div className="course-lesson-wrap">
            {props?.image &&
                <div className="course-img-wrap d-flex overflow-hidden position-relative" style={{maxHeight: '300px'}}>
                    <img src={props?.image} alt="Lesson" className="w-100" style={{objectFit: 'cover'}} />
                    <div className="course-img-overlay position-absolute w-100 h-100 d-flex justify-content-center align-items-center flex-column">
                        <div className="flex-grow-1 d-flex align-items-center">
                            {/* <h1 className="text-white text-center">{lessonTitle}</h1> */}
                        </div>

                        { (lesson || topic ) &&
                            <span className="text-white p-3 d-flex w-100 dark-overlay">
                                <span className="text-white pe-3"><i className="fa fa-long-arrow-left" aria-hidden="true"></i></span>
                                <Link to={`/${props?.slug}`} className="text-white">Go tillbaka</Link>
                            </span>
                        }
                        
                    </div>
                    {props?.topics[0] &&
                        <CourseProgress topic={props?.topics[0].ID} courseID={props?.courseID} />
                    }
                    { ! props?.topics[0] &&
                        <CourseProgress courseID={props?.courseID} />
                    }
                </div>
            }
            
            <StickyContainer>
                <div className="mx-auto mt-4 px-3" style={{ maxWidth: "1400px" }}>
                    <div className="row">
                        <div className="col-12 col-lg-3">
                            <Sticky >{({ style, isSticky }) => <div style={style} className={`${isSticky ? 'instructions-is-sticky' : ''}`} >
                                <CourseNav courseData={props?.allData} slug={props?.slug} />
                            </div>}</Sticky>
                        </div>
                        <div className="col-12 col-lg-9">
                           <div className="row">
                            <div className="col-12 px-3 px-lg-5">
                                <div className="text-lg" dangerouslySetInnerHTML={{__html: props?.content}}></div>
                            </div>
                           </div>
                        </div>
                    </div>
                </div>
            </StickyContainer>
        </div>
    )
}

export default CourseLesson;